import {Point} from '@angular/cdk/drag-drop';

/**
 * Calculate the distance for the x- and y-axis between two points.
 */
export function calcDistance(pointA: Point, pointB: Point): Point {
  const x = pointB.x - pointA.x;
  const y = pointB.y - pointA.y;

  // ---- If we ever need to calculate the total line length from point to point, here is the 'formula': ----
  // return Math.sqrt(x*x + y*y);

  return {x, y};
}

export function getPointFromMouseEvent(event: MouseEvent): Point {
  return  {
    x: event.x,
    y: event.y
  };
}
